<template>
	<div class="pay-situation-detail-container">
		<div class="content">
			<mobile-card :show-footer="true">
				<template slot="title">{{ title }}</template>

				<template slot="content" v-if="detail">
					<!-- 应交部分 -->
					<div v-if="$utils.isNotEmpty(detail.needAllMoney) || $utils.isNotEmpty(detail.needMoney)">
						<div class="flex-form-info" v-if="$utils.isNotEmpty(detail.needMoney)">
							<span>{{ pageText.need_money }}</span>
							<span>{{ detail.needMoney | formatMoney }}</span>
						</div>

						<div class="flex-form-info" v-if="$utils.isNotEmpty(detail.delayMoney)">
							<span>{{ pageText.later_money }}</span>
							<span>{{ detail.delayMoney | formatMoney }}</span>
						</div>

						<div class="mobile-card-line van-hairline--top"></div>
						<div class="flex-form-sum sum-text">
							<span>{{ pageText.sum_need_pay }}</span>
							<span>{{ detail.needAllMoney | formatMoney }}</span>
						</div>
					</div>

					<!-- 已交部分 -->
					<div>
						<div v-if="$utils.isNotEmpty(detail.payRecordVOS)">
							<div class="flex-form-info" v-for="(item, index) in detail.payRecordVOS" :key="index">
								<span>{{ item.payTypeName }}</span>
								<span>{{ item.payTime }}</span>
								<span>{{ item.payMoney | formatMoney }}</span>
							</div>
						</div>

						<div v-if="$utils.isNotEmpty(detail.deductionVos)">
							<div class="flex-form-info" v-for="(item, index) in detail.deductionVos" :key="index">
								<span>{{ pageText.deduction }}</span>
								<span>{{ getDeductionText(item) }}</span>
								<span>{{ item.money | formatMoney }}</span>
							</div>
						</div>

						<div class="mobile-card-line van-hairline--top"></div>
						<div class="flex-form-sum sum-text">
							<span>{{ pageText.sum_already_pay }}</span>
							<span>{{ detail.alreadymoney | formatMoney }}</span>
						</div>
					</div>
				</template>

				<template slot="footer" v-if="nowMoneyShowed">
					<div class="flex-form-sum sum-text">
						<span>{{ pageText.nowMoney }}</span>
						<span>{{ detail.nowMoney | formatMoney }}</span>
					</div>
				</template>
			</mobile-card>
		</div>
		<div class="footer">
			<div class="footer-bar">
				<van-button color="#005423" block @click="onBack">{{ pageText.pre_page }}</van-button>
			</div>
		</div>
		<van-overlay :show="loading" @click="loading = false">
			<div style="display: flex; align-items: center; justify-content: center; height: 100%" @click.stop>
				<van-loading vertical>{{ pageText.loading }}</van-loading>
			</div>
		</van-overlay>
	</div>
</template>

<script>
import storage from 'good-storage'
import MobileCard from 'components/mobile-card/index'
import apiPaySituation from 'api/pay-situation'
import utils from '@/utils/util'

export default {
	name: 'paySituationDetail',
	components: { MobileCard },

	data() {
		return {
			payItem: {},
			detail: {},
			title: '',
			nowMoneyShowed: true,
			loading: false,
			pageText: {
				loading: this.$t('pay_situation.loading'),
				sum_need_pay: this.$t('pay_situation_detail.sum_need_pay'),
				sum_already_pay: this.$t('pay_situation_detail.sum_already_pay'),
				nowMoney: this.$t('pay_situation_detail.nowMoney'),
				pre_page: this.$t('pay_situation.pre_page'),
				name: this.$t('pay_situation.list.name'),
				range: this.$t('pay_situation.list.range'),
				need_money: this.$t('pay_situation.list.need_money'),
				later_money: this.$t('pay_situation.list.later_money'),
				receive_money: this.$t('pay_situation.list.receive_money'),
				deduction: this.$t('pay_situation_detail.deduction')
			}
		}
	},

	activated() {
		this.getPayItem()
	},

	methods: {
		getPayItem() {
			this.detail = {}
			let payItem = storage.session.get('pay-item', {})
			this.payItem = payItem
			let param = {
				arrearId: payItem.arrearId,
				orderNo: payItem.orderNo
			}
			this.loading = true
			apiPaySituation.detail(param).then(res => {
				this.loading = false
				this.detail = res.data || {}
				if (utils.isNotEmpty(this.detail.intervalName)) {
					this.title = `${this.detail.intervalName}${this.detail.itemName}`
				} else {
					this.title = this.detail.itemName
				}

				// 应收计入待追缴 显示当前应交 + 已交 + 当前需交
				this.nowMoneyShowed = param.arrearId != null && this.detail.isPursued === 1
			})
		},

		getDeductionText(item) {
			let s = ''
			if (item.time) {
				s = `${item.time}  `
				if (item.typeName) {
					let s2 = `${item.typeName}`
					s += s2
				}
			} else {
				if (item.typeName) {
					let s2 = `${item.typeName}`
					s += s2
				}
			}
			return s
		},

		onBack() {
			this.$router.back()
		}
	}
}
</script>

<style lang="scss" scoped></style>
